import { Button, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { Circle } from "@mui/icons-material";
import { useRecordContext } from "react-admin";
import DownloadFieldLink from "../../unit/DownloadFieldLink";
export default function Documents({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "documents";
  const sectionTitle =
    "Documents - Specify the legal document templates used through various stages";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.templates;
  const pId = record?.data?.basic?.id;
  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({});
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  const handleDownloadFile = () => {
    // pId
  };
  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {data?.productEventTemplateStatus && (
              <>
                {/* xxx : red icon , event : status */}
                {data?.productEventTemplateStatus.map((event, index) => (
                  <>
                    <Button
                      variant="text"
                      sx={{
                        textTransform: "none",
                        color: "black",
                        marginRight: 2,
                      }}
                      startIcon={
                        <Circle
                          sx={{
                            width: 15,
                            verticalAlign: "middle",
                            mt: 0,
                            ml: 0,
                            color: event?.status == "red" ? "red" : "green",
                          }}
                        />
                      }
                    >
                      {event.event}
                    </Button>
                  </>
                ))}
              </>
            )}
            {/* if have red, Required document templates are missing for the following events: Application, Decline, Counter, Approve. */}
            {data?.productEventTemplateStatus?.some(
              (event) => event.status === "red"
            ) && (
              <Typography variant="body2" sx={{ mt: 2 }}>
                Required document templates are missing for the following
                events:
                <span style={{ color: "red", fontWeight: "bold" }}>
                  {data?.productEventTemplateStatus
                    .filter((event) => event.status === "red")
                    .map((event) => event.event)
                    .join(", ")}
                </span>
              </Typography>
            )}
            {/* <Box sx={{ mt: 2 }}>
              <Button
                variant="text"
                onClick={() => handleDownloadFile()}
                component={Link}
                sx={{ textTransform: "none" }}
              >
                <OpenInNewIcon sx={{ fontSize: "18px" }} />
                &nbsp; Download templates
              </Button>*/}
            {data?.isDownload && (
              <Box sx={{ mt: 2 }}>
                Download templates{" "}
                <DownloadFieldLink
                  filelink={`products/downloadTemplate/p-${pId}`}
                  filename={`product_${pId}_templates.zip`}
                  sx={{ textTransform: "none", color: "#1976d2" }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </SectionStyled>
  );
}
